export default {
  notes: {
    en: 'Notes',
  },
  productTitle: {
    female: {
      en: '{note} perfumes',
    },
    male: {
      en: '{note} colognes',
    },
  },
  try: {
    en: 'Try for $14.95',
  },
}
